class HouseDrawer {
  constructor(root) {
    this.root = root;
    this.toggle = root.querySelector('[data-drawer-toggle]');
    this.drawer = root.querySelector('[data-drawer]');
    this.close = root.querySelector('[data-drawer-close]');
    this.lastFocused = null;
    this.toggle?.addEventListener('click', () => this.open());
    this.close?.addEventListener('click', () => this.hide());
    this.drawer?.addEventListener('click', (event) => {
      if (event.target === this.drawer) this.hide();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen()) this.hide();
      if (event.key === 'Tab' && this.isOpen()) this.trapFocus(event);
    });
  }

  isOpen() { return this.drawer && !this.drawer.hidden; }

  open() {
    if (!this.drawer) return;
    this.lastFocused = document.activeElement;
    this.drawer.hidden = false;
    this.toggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('drawer-open');
    this.drawer.querySelector('button, a, input, summary')?.focus();
  }

  hide() {
    if (!this.drawer) return;
    this.drawer.hidden = true;
    this.toggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-open');
    this.lastFocused?.focus();
  }

  trapFocus(event) {
    const focusable = [...this.drawer.querySelectorAll('a, button, input, summary, [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.hasAttribute('disabled'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}

document.querySelectorAll('[data-house-header]').forEach((header) => new HouseDrawer(header));

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-house-header]').forEach((header) => new HouseDrawer(header));
});
